import { cn } from '@rocco/utils/cn';
import { Badge } from '@rocco/components/badge';

/**
 * A badge representing the number of notifications or unread messages. This
 * component is hidden when the count is `0`.
 */
export function NotificationBadge({
    className,
    count = 0,
    preserveSpace = false,
}: {
    className?: string;
    /**
     * The number of notifications or unread messages. Defaults to `0`.
     */
    count?: number;
    /**
     * Preserve the space allocated for the badge even when it is hidden.
     * Defaults to `false`.
     */
    preserveSpace?: boolean;
}) {
    return (
        <Badge
            className={cn(
                !count && (preserveSpace ? 'invisible' : 'hidden'),
                className
            )}
            size="centeredCompact"
            color="red"
            contentOverflow="visible"
        >
            {count > 9 ? '9+' : count}
        </Badge>
    );
}
